import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    let errorDetails = null;
    try {
      const errorBody = await response.clone().json();
      errorDetails = errorBody;
    } catch {
      const errorText = await response.clone().text();
      errorDetails = errorText;
    }
    const error = new Error(`HTTP error! status: ${response.status}`);
    error.status = response.status;
    error.details = errorDetails;
    throw error;
  }

  if (response.status === 204) return null;
  return response.json();
};

export const getEventDashboard = async (startDate = null, endDate = null) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  const query = params.toString() ? `?${params.toString()}` : '';
  return makeRequest(`${API_BASE_URL}/api/event-dashboard${query}`);
};
